var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2344_811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C12.7833 15 13.0208 14.9042 13.2125 14.7125C13.4042 14.5208 13.5 14.2833 13.5 14C13.5 13.7167 13.4042 13.4792 13.2125 13.2875C13.0208 13.0958 12.7833 13 12.5 13C12.2167 13 11.9792 13.0958 11.7875 13.2875C11.5958 13.4792 11.5 13.7167 11.5 14C11.5 14.2833 11.5958 14.5208 11.7875 14.7125C11.9792 14.9042 12.2167 15 12.5 15ZM11.5 11H13.5V5H11.5V11ZM12.5 20C11.1167 20 9.81667 19.7375 8.6 19.2125C7.38333 18.6875 6.325 17.975 5.425 17.075C4.525 16.175 3.8125 15.1167 3.2875 13.9C2.7625 12.6833 2.5 11.3833 2.5 10C2.5 8.61667 2.7625 7.31667 3.2875 6.1C3.8125 4.88333 4.525 3.825 5.425 2.925C6.325 2.025 7.38333 1.3125 8.6 0.7875C9.81667 0.2625 11.1167 0 12.5 0C13.8833 0 15.1833 0.2625 16.4 0.7875C17.6167 1.3125 18.675 2.025 19.575 2.925C20.475 3.825 21.1875 4.88333 21.7125 6.1C22.2375 7.31667 22.5 8.61667 22.5 10C22.5 11.3833 22.2375 12.6833 21.7125 13.9C21.1875 15.1167 20.475 16.175 19.575 17.075C18.675 17.975 17.6167 18.6875 16.4 19.2125C15.1833 19.7375 13.8833 20 12.5 20ZM12.5 18C14.7333 18 16.625 17.225 18.175 15.675C19.725 14.125 20.5 12.2333 20.5 10C20.5 7.76667 19.725 5.875 18.175 4.325C16.625 2.775 14.7333 2 12.5 2C10.2667 2 8.375 2.775 6.825 4.325C5.275 5.875 4.5 7.76667 4.5 10C4.5 12.2333 5.275 14.125 6.825 15.675C8.375 17.225 10.2667 18 12.5 18Z",
    fill: "#F04D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C12.7833 15 13.0208 14.9042 13.2125 14.7125C13.4042 14.5208 13.5 14.2833 13.5 14C13.5 13.7167 13.4042 13.4792 13.2125 13.2875C13.0208 13.0958 12.7833 13 12.5 13C12.2167 13 11.9792 13.0958 11.7875 13.2875C11.5958 13.4792 11.5 13.7167 11.5 14C11.5 14.2833 11.5958 14.5208 11.7875 14.7125C11.9792 14.9042 12.2167 15 12.5 15ZM11.5 11H13.5V5H11.5V11ZM12.5 20C11.1167 20 9.81667 19.7375 8.6 19.2125C7.38333 18.6875 6.325 17.975 5.425 17.075C4.525 16.175 3.8125 15.1167 3.2875 13.9C2.7625 12.6833 2.5 11.3833 2.5 10C2.5 8.61667 2.7625 7.31667 3.2875 6.1C3.8125 4.88333 4.525 3.825 5.425 2.925C6.325 2.025 7.38333 1.3125 8.6 0.7875C9.81667 0.2625 11.1167 0 12.5 0C13.8833 0 15.1833 0.2625 16.4 0.7875C17.6167 1.3125 18.675 2.025 19.575 2.925C20.475 3.825 21.1875 4.88333 21.7125 6.1C22.2375 7.31667 22.5 8.61667 22.5 10C22.5 11.3833 22.2375 12.6833 21.7125 13.9C21.1875 15.1167 20.475 16.175 19.575 17.075C18.675 17.975 17.6167 18.6875 16.4 19.2125C15.1833 19.7375 13.8833 20 12.5 20ZM12.5 18C14.7333 18 16.625 17.225 18.175 15.675C19.725 14.125 20.5 12.2333 20.5 10C20.5 7.76667 19.725 5.875 18.175 4.325C16.625 2.775 14.7333 2 12.5 2C10.2667 2 8.375 2.775 6.825 4.325C5.275 5.875 4.5 7.76667 4.5 10C4.5 12.2333 5.275 14.125 6.825 15.675C8.375 17.225 10.2667 18 12.5 18Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2344_811",
    x: -1.5,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2344_811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2344_811",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f7f4762709b1adefd82fc3e671e5ab39.svg";
export { ForwardRef as ReactComponent };